<template>
  <!--
    Global activity indicator, shown while `store.state.startLoader` is true. Two parts:
      1) a slim non-blocking top progress bar (visual feedback), and
      2) a TRANSPARENT click-shield that swallows clicks for the duration of the action,
         so a button can't be double-clicked into firing twice (e.g. two renewals / two
         invoices). It's invisible — not the old full-page loader — it only blocks input
         for the brief moment a request is in flight.
  -->
  <div class="mi-topbar" role="progressbar" aria-label="Loading">
    <div class="mi-topbar-indicator"></div>
  </div>
  <div class="mi-click-shield" aria-hidden="true"></div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
$primary_color: #1d2088;
$secondary_color: #1eb9ee;

.mi-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 1000000;
  pointer-events: none;
  background: rgba(29, 32, 136, 0.1);
  overflow: hidden;
}
.mi-topbar-indicator {
  position: absolute;
  top: 0;
  height: 100%;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(90deg, $primary_color, $secondary_color);
  box-shadow: 0 0 8px rgba(30, 185, 238, 0.5);
  animation: mi-indeterminate 1.1s infinite ease-in-out;
}

/* Invisible full-viewport shield: catches clicks (incl. on modal OK buttons, which sit
   around z-index 1000) so the in-flight action can't be triggered a second time. */
.mi-click-shield {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: transparent;
  cursor: progress;
}

@keyframes mi-indeterminate {
  0% {
    left: -40%;
    width: 40%;
  }
  50% {
    left: 30%;
    width: 55%;
  }
  100% {
    left: 100%;
    width: 40%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .mi-topbar-indicator {
    animation-duration: 2s;
  }
}
</style>
